import { createSlice } from '@reduxjs/toolkit'
import { getSettings,updateSettings } from './settingsActions'
import { patchTaxesEnabled } from '../taxSettings/taxSettingsActions'


const initialState = {
  loading: false,
  error: null,
  success: false,
  settings:{}
}

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = null;
      state.loading = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSettings.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getSettings.fulfilled, (state, { payload }) => {
        state.loading = false
        state.settings = payload
        state.error = null
      })
      .addCase(getSettings.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload
      })
      .addCase(updateSettings.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateSettings.fulfilled, (state, { payload }) => {
        state.loading = false
        state.settings = payload
        state.error = null
      })
      .addCase(updateSettings.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload
      })
      // [CANA-591] the Tax tab toggles the same column through taxes/settings/;
      // keep a loaded settings/ in step so the tabs don't disagree.
      .addCase(patchTaxesEnabled.fulfilled, (state, { payload }) => {
        if (state.settings && 'is_taxes_enabled' in state.settings) {
          state.settings.is_taxes_enabled = payload?.is_taxes_enabled
        }
      });
  },
})
export const { resetError } = settingsSlice.actions;
export default settingsSlice.reducer